import { HARD_PATHS } from '../utils/hard-paths';

const moduleRoot = `/store`;

export const PATHS = {
    STORE: {
        path: `${moduleRoot}`,
    },
    PAY2GO: {
        path: `${moduleRoot}/strata`,
        hardPath: HARD_PATHS.STORE.PAY2GO,
    },
    PLUGINS: {
        path: `${moduleRoot}/plugins`,
        hardPath: HARD_PATHS.STORE.PLUGINS,
    },
    CERTIFICATIONS: {
        path: `${moduleRoot}/certifications`,
    },
    PURCHASE_CERTIFICATION: {
        path: `${moduleRoot}/purchase-certification/:courseId`,
        hardPath: HARD_PATHS.STORE.PURCHASE_CERTIFICATION,
    },
    STRATA: {
        path: `/strata-library/sound-effects-collections`,
    },
    STRATA_LIBRARY: {
        path: `/strata-library/sound-effects-collections/:libraryId`,
    },
};
